import {combineReducers} from 'redux'
import global from '../actions/index'
export default combineReducers({
    global,

})
